import { render, staticRenderFns } from "./companycontent.vue?vue&type=template&id=7cf59d56"
import script from "./companycontent.vue?vue&type=script&lang=js"
export * from "./companycontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports